import { useIntl } from "react-intl";

import { useSearchParameters } from "@/components/signup/hooks";

import { useConfirmationPage } from "../../hooks/use-confirmation-page";
import { getProductQueryParamTeamType } from "../../models/user-segmentation";

import {
    SampleProjectConfigurations,
    defaultSampleProjectConfiguration,
    KANBAN_PROJECT_DEFAULTS
} from "./types";

const getSampleProjectConfiguration = (teamType: string) => {
    return (
        SampleProjectConfigurations[teamType] ??
        defaultSampleProjectConfiguration
    );
};

export const useSampleProjectConfiguration = () => {
    const intl = useIntl();
    const {
        userSegmentationContext: { selectedTeamType = "" }
    } = useConfirmationPage();
    const { teamType: queryParamTeamType } = useSearchParameters();

    const teamType = selectedTeamType ?? queryParamTeamType;
    const teamTypeShorthand = getProductQueryParamTeamType(teamType);

    const config = getSampleProjectConfiguration(teamType);

    const sampleProjectConfiguration = {
        ...config,
        columns: config.columns.map((column) => column),
        issueTypes: config.issueTypes.map((issueType) => ({
            ...issueType,
            name: issueType.name
        }))
    };

    const projectDetails = {
        ...KANBAN_PROJECT_DEFAULTS,
        defaultProjectName: intl.formatMessage(
            KANBAN_PROJECT_DEFAULTS.defaultProjectName
        )
    };

    return {
        teamType: teamTypeShorthand,
        sampleProjectConfiguration,
        projectDetails
    };
};
